import axios from "axios";

const token = localStorage.getItem('token');
// Access the environment variable for the API base URL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`, // Set the token from env
  },
});

export const useDeleteCourseFavorite = () => {
    const deleteCourseFavorite = async (customerId, courseId) => {
      try {
        const response = await axiosInstance.delete(`/api/Courses/remove-course-from-favorites?customerId=${customerId}&courseId=${courseId}`);
         console.log(response.data);
         
        return response.data;
      } catch (error) {
        console.log(error);
        
        throw error;
      }
    };
  
    return { deleteCourseFavorite };
  };
  